import { useTranslation } from 'react-i18next';
import { EpisodeCard } from 'shared/components/EpisodeCard/EpisodeCard';
import { Heading } from 'shared/components/Heading';
import { RevealItem } from 'shared/components/RevealItem/RevealItem';
import { useScrollReveal } from 'shared/hooks/useScrollReveal';
import { useAudioPlayerControls } from 'shared/hooks/useAudioPlayer';
import type { PublishedEpisode } from 'shared/data/episodes';

type ExploreMoreProps = {
  episodes: PublishedEpisode[];
};

export function ExploreMore({ episodes }: ExploreMoreProps) {
  const { t } = useTranslation('episodeDetail');
  const { play } = useAudioPlayerControls();
  const heading = useScrollReveal({ animation: 'float-up' });

  if (episodes.length === 0) return null;

  return (
    <section className="max-w-7xl mx-auto px-6 lg:px-12 mt-20 md:mt-48">
      <Heading variant="section" innerRef={heading.ref} style={heading.style} className="mb-12 text-center md:text-4xl">
        {t('explore.title')}
      </Heading>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {episodes.map((episode, i) => (
          <RevealItem key={episode.number} index={i}>
            <EpisodeCard
              {...episode}
              onPlay={episode.audioUrl ? () => play(episode) : undefined}
            />
          </RevealItem>
        ))}
      </div>
    </section>
  );
}
